<template>
  <div class="pe-home">
    <div class="pe-home__hero">
      <div class="pe-home__icon">
        <v-icon color="white" size="28">mdi-clipboard-pulse-outline</v-icon>
      </div>
      <div>
        <h1>Procedimientos de Enfermería</h1>
        <p>Seleccione un módulo en el menú lateral para comenzar</p>
      </div>
    </div>
    <div class="pe-home__card">
      <v-icon size="52" color="#94a3b8">mdi-view-dashboard-outline</v-icon>
      <h2>Bienvenido</h2>
      <p>
        Use el menú de la izquierda para acceder a formularios, programación,
        enfermeras y demás opciones del módulo.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcedimientosEnfermeriaHome',
}
</script>

<style scoped>
.pe-home {
  --navy: #0b3d78;
}
.pe-home__hero {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
}
.pe-home__icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(145deg, #0b5cad, #074a8c);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pe-home__hero h1 {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  color: #0f172a;
}
.pe-home__hero p {
  margin: 0.2rem 0 0;
  color: #64748b;
  font-size: 0.9rem;
}
.pe-home__card {
  background: #fff;
  border: 1px solid #e4e8ee;
  border-radius: 12px;
  padding: 2.5rem 1.5rem;
  text-align: center;
  color: #64748b;
}
.pe-home__card h2 {
  margin: 0.75rem 0 0.35rem;
  color: #0f172a;
  font-size: 1.15rem;
}
.pe-home__card p {
  margin: 0 auto;
  max-width: 420px;
  font-size: 0.9rem;
  line-height: 1.45;
}
</style>
